import * as icons from "react-icons/bi";
import { ListButton, MarkButton } from "../components";

export const DEFAULT_ACTIONS = [
  "BoldText",
  "ItalicText",
  "UnderlineText",
  "NumberedList",
  "BulletedList"
];

export const ACTIONS_BY_KEY: { [key: string]: any } = {
  BoldText: () =>
    MarkButton({
      mark: "bold",
      icon: icons.BiBold,
      title: "Mark selected text as bold"
    }),
  ItalicText: () =>
    MarkButton({
      mark: "italic",
      icon: icons.BiItalic,
      title: "Mark selected text as italic"
    }),
  UnderlineText: () =>
    MarkButton({
      mark: "underline",
      icon: icons.BiUnderline,
      title: "Underline selected text"
    }),
  NumberedList: () =>
    ListButton({
      listType: "numbered-list",
      icon: icons.BiListOl,
      title: "Create numbered list"
    }),
  BulletedList: () =>
    ListButton({
      listType: "bulleted-list",
      icon: icons.BiListUl,
      title: "Create bulleted list"
    })
};
